(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    // Interceta apenas os accordions "link-only" (sem conteúdo)
  // e navega para o link SEM alterar layout/estilos.
  document.addEventListener('click', (e) => {
    const summary = e.target.closest('details[data-accordion-link] > summary');
    if (!summary) return;

    e.preventDefault(); // impede abrir/fechar o <details> (mantém aparência igual)
    const details = summary.closest('details[data-accordion-link]');
    const url = details?.getAttribute('data-accordion-link');
    if (url) window.location.href = url;
  });

  document.addEventListener('keydown', (e) => {
    // Acessibilidade: Enter/Space também navegam (e não togglam)
    if (e.key !== 'Enter' && e.key !== ' ') return;

    const summary = document.activeElement?.closest?.('details[data-accordion-link] > summary');
    if (!summary) return;

    e.preventDefault();
    const details = summary.closest('details[data-accordion-link]');
    const url = details?.getAttribute('data-accordion-link');
    if (url) window.location.href = url;
  });
  } catch(e) { console.error(e); }
})();

})();
